<template>
  <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini" style="width: 100%;">
         <div class="formItemBox">
             <el-form-item label="所在仓库:" prop="organizationId">
                <el-select  v-model="searchFrom.organizationId"  placeholder="">
                  <el-option v-for="val in warehouseList" :label="val.relTenantName" :value="val.relTenantCode" :key="val.relTenantCode"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="货物类型:" class="jiage" prop="productType">
                <el-select  v-model="searchFrom.productType"  value-key="productId" >
                  <el-option v-for="item in productTypes" :label="item.show_name" :value="item.item_no" :key="item.item_no"></el-option>
                </el-select>
              </el-form-item>
               <el-form-item label="控货方:" prop="oneCustomerName" v-if="tableArr[0]">
                <el-input  placeholder="" v-model="searchFrom.oneCustomerName"></el-input>
              </el-form-item>
              <el-form-item label="产地:" prop="steelMillName">
                <el-input  placeholder="" v-model="searchFrom.steelMillName"></el-input>
              </el-form-item>
               <el-form-item label="材质:" prop="model">
                <el-input  placeholder="" v-model="searchFrom.model"></el-input>
              </el-form-item>
        </div>
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
                 <el-form-item >
                  <el-button type="primary"  @click="exportFn" :disabled="isDisable">导出</el-button>
                </el-form-item>
                <el-form-item>
                  <p class="margin0">总件数：<span class="red">{{tongji.totalNumber}}</span>件</p>
                </el-form-item>
                <el-form-item>
                  <p class="margin0">总重量：<span class="red">{{tongji.totalAllWeight}}</span>吨</p>
                </el-form-item>
            </div>
      </el-form>
    </div>
     <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  class="tableComent"
        style="width: 100%" height="100%"  center border >
       <el-table-column type="index" prop="date"  width="55" label="序号"></el-table-column>
        <!-- <el-table-column label="操作" width="90" >
          <template slot-scope="scope">
            <div>
            <el-button type="text" size="mini"   @click="yuxuanFN(scope.row)">预选</el-button>
              </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="ownerCustomerName"  min-width="200" v-if="tableArr[1]" :formatter="emptyFn" label="货权方"></el-table-column>
        <el-table-column prop="oneCustomerName"  min-width="200" v-if="tableArr[0]" :formatter="emptyFn" label="控货方"></el-table-column>
        <el-table-column property="productTypeName"  width="100" label="货物类型"></el-table-column>
        <el-table-column property="steelMillName" width="200"  label="产地"></el-table-column>
        <el-table-column property="specification" width="120"  label="规格"></el-table-column>
        <el-table-column property="model" width="120" :formatter="emptyFn" label="材质"></el-table-column>
        <!-- <el-table-column property="root" width="120" :formatter="emptyFn"  label="单件支数"></el-table-column>
        <el-table-column property="length"  width="100" :formatter="emptyFn" label="长度(m)"></el-table-column> -->
        <el-table-column property="number" width="120" :formatter="emptyFn"  label="总件数"></el-table-column>
        <el-table-column property="singletonWeight" width="130"   label="单件理重(吨)"></el-table-column>
        <el-table-column property="allWeight" width="130" label="总重量(吨)"></el-table-column>
        <el-table-column property="stockWeight" width="130"   label="总理重(吨)"></el-table-column>
        <el-table-column property="stockPoundWeight" width="130"   label="总磅重(吨)"></el-table-column>

            <el-table-column property="organizationName" width="200"  label="所在仓库"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { getDictionaryAll, getStockThreadList, getStockThreadTotalWN, getOrganizationNameList,
  findExtAttritude } from '@/api/soc-stock-cosco'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { getAttribute } from '@/utils/getButton'
export default {
  data () {
    return {
      tableArr: [],
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      productTypes: [],
      warehouseList: [],
      total: 0,
      loading: 'false',
      isDisable: false,
      tongji: {},
      oneCustomerTaxId: localStorage.getItem('tenantTaxpayerNumber'),
      ownerCustomerName: localStorage.getItem('tenantName')
    }
  },
  created () {
    this.searchFrom.ownerCustomerName = this.ownerCustomerName
    this.tableArr = getAttribute('ARRoneCustomerName,ARRownerCustomerName')
    getDictionaryAll({ groupNo: 'thread_product_type' }).then(res => {
      this.productTypes = res
      this.productTypes.unshift({ show_name: '全部', item_no: '' })
    })
    if (localStorage.getItem('isCutCrm3') == 1) {
      this.warehouseList = [{
        relTenantName: localStorage.getItem('createTenantName'),
        relTenantCode: localStorage.getItem('createTenantCode')
      }]
      this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
      this.getList()
    } else {
      getOrganizationNameList({
        userCode: localStorage.getItem('userCode'),
        tenantCode: localStorage.getItem('tenantCode')
      }).then(res => {
        this.warehouseList = res
        if (res.length > 0) {
          this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
        }
        this.getList()
      })
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
  },
  methods: {
    // 导出
    exportFn () {
      let falg = this.tableArr[0]
      let form = this.searchFrom
      form.oneCustomerNameFlag = falg
      exportExcel(
        this.global.wmsStockName + '/recordDetails/exportStockThreadList',
        form,
        '库存记录'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    searchFn () {
      this.getList()
    },
    // 选择数据

    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      getStockThreadList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
      getStockThreadTotalWN(this.searchFrom).then(res => {
        this.tongji = res
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        ownerCustomerName: this.ownerCustomerName
      }
      this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
    },

    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
  width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
</style>
